import { Tag } from "@vp/models";

export interface MultiTagSelectorStateModel {
  selectedTags: Tag[];
}

export const defaultMultiTagSelectorState = (): MultiTagSelectorStateModel => {
  return {
    selectedTags: []
  };
};
